/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var SocialLinkLang = /** @class */ (function () {
        function SocialLinkLang() {
        }
        SocialLinkLang.getLabelText = function () {
            return moya.lang === 'is' ? 'Deila' : 'Share';
        };
        SocialLinkLang.getFacebookShareText = function () {
            return moya.lang === 'is' ? 'Deila á Facebook' : 'Share on Facebook';
        };
        SocialLinkLang.getTwitterShareText = function () {
            return moya.lang === 'is' ? 'Deila á Twitter' : 'Share on Twitter';
        };
        SocialLinkLang.getPrintShareText = function () {
            return moya.lang === 'is' ? 'Prenta síðu' : 'Print page';
        };
        return SocialLinkLang;
    }());

    var util = MoyaContainer.get('core.util');
    MoyaContainer.register('ext.social.links', function () {
        return {
            init: SocialLinks.create,
            getStylesheetUrl: SocialLinks.getStylesheetUrl,
        };
    });
    var SocialLinks = /** @class */ (function () {
        function SocialLinks(el) {
            this.mainElm = el;
            this.currentUrl = this.getCurrentUrl(el);
            this.currentTitle = this.getCurrentTitle(el);
            this.hasTwitter = !!el.dataset.hasTwitter;
            this.hasFacebook = !!el.dataset.hasFacebook;
            this.hasPrint = !!el.dataset.hasPrint;
            this.hasEmail = !!el.dataset.hasEmail;
        }
        SocialLinks.create = function (el) {
            return new SocialLinks(el).run();
        };
        SocialLinks.getStylesheetUrl = function () {
            var cacheBust = '';
            Array.from(document.styleSheets)
                .filter(function (e) { return e.href && e.href.indexOf('theme.css') !== -1; })
                .map(function (e) { return e.href; })
                .forEach(function (stylesheet) {
                cacheBust = stylesheet.split('?')[1];
                if (stylesheet.split('?')[1] !== '') {
                    cacheBust = Number(stylesheet.split('?')[1]).toString();
                }
            });
            return '/static/local/ext-social/css/social-links.css?' + cacheBust;
        };
        SocialLinks.prototype.run = function () {
            this.mainElm.classList.add('loaded');
            SocialLinks.loadStyles();
            this.mainElm.appendChild(this.createSocialLinks());
            this.handleShareThisLinks();
        };
        SocialLinks.loadStyles = function () {
            var stylesheetUrl = SocialLinks.getStylesheetUrl();
            if (!stylesheetUrl) {
                return;
            }
            MoyaLoader.css(stylesheetUrl);
        };
        SocialLinks.prototype.createSocialLinks = function () {
            var wrapper = this.createWrapper();
            this.addLabel(wrapper);
            var toolboxDiv = document.createElement('div');
            toolboxDiv.classList.add('social__toolbox');
            if (this.hasFacebook) {
                toolboxDiv.appendChild(this.createFaceBookLink());
            }
            if (this.hasTwitter) {
                toolboxDiv.appendChild(this.createTwitterLink());
            }
            if (this.hasPrint) {
                toolboxDiv.appendChild(this.createPrintLink());
            }
            if (this.hasEmail) {
                toolboxDiv.appendChild(this.createEmailLink());
            }
            wrapper.appendChild(toolboxDiv);
            return wrapper;
        };
        SocialLinks.prototype.createWrapper = function () {
            var socialToolboxDiv = document.createElement('div');
            socialToolboxDiv.classList.add('social__wrapper');
            return socialToolboxDiv;
        };
        SocialLinks.prototype.addLabel = function (socialToolboxDiv) {
            var socialLabelDiv = document.createElement('div');
            socialLabelDiv.classList.add('social__label');
            socialLabelDiv.textContent = SocialLinkLang.getLabelText();
            socialToolboxDiv.appendChild(socialLabelDiv);
        };
        SocialLinks.prototype.createEmailLink = function () {
            var emailLink = document.createElement('a');
            emailLink.href = 'mailto:?subject=' + encodeURIComponent(this.currentTitle) + '&body=' + this.currentUrl;
            emailLink.classList.add('email');
            return emailLink;
        };
        SocialLinks.prototype.createPrintLink = function () {
            var printLink = document.createElement('button');
            printLink.setAttribute('aria-label', SocialLinkLang.getPrintShareText());
            printLink.classList.add('print');
            printLink.type = 'button';
            printLink.onclick = function () {
                window.print();
                return false;
            };
            return printLink;
        };
        SocialLinks.prototype.createTwitterLink = function () {
            var twitterLink = document.createElement('a');
            var params = {
                url: this.currentUrl,
                text: this.currentTitle,
            };
            var urlSearchParams = new URLSearchParams(params);
            twitterLink.href = 'https://twitter.com/intent/tweet?url=' + urlSearchParams.toString();
            twitterLink.target = '_blank';
            twitterLink.setAttribute('aria-label', SocialLinkLang.getTwitterShareText());
            twitterLink.classList.add('shareThis');
            twitterLink.classList.add('twitter');
            return twitterLink;
        };
        SocialLinks.prototype.createFaceBookLink = function () {
            var facebookLink = document.createElement('a');
            facebookLink.href = 'https://facebook.com/sharer/sharer.php?u=' + this.currentUrl;
            facebookLink.target = '_blank';
            facebookLink.setAttribute('aria-label', SocialLinkLang.getFacebookShareText());
            facebookLink.classList.add('shareThis');
            facebookLink.classList.add('facebook');
            return facebookLink;
        };
        SocialLinks.prototype.handleShareThisLinks = function () {
            var _this = this;
            this.mainElm.querySelectorAll('.shareThis').forEach(function (item) {
                var lastClass = item.classList[item.classList.length - 1];
                util.delegate(item, 'click', '.social__toolbox .' + lastClass, function (e) {
                    e.preventDefault();
                    _this.openNewWindow(item.href, _this.currentTitle, 569, 569);
                });
            });
        };
        SocialLinks.prototype.openNewWindow = function (url, title, width, height) {
            var dualScreenLeft = window.screenLeft;
            var dualScreenTop = window.screenTop;
            var w = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            var h = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
            var left = ((w / 2) - (width / 2)) + dualScreenLeft;
            var top = ((h / 2) - (height / 2)) + dualScreenTop;
            var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
            if (window.focus) {
                newWindow.focus();
            }
        };
        SocialLinks.prototype.getCurrentUrl = function (el) {
            var customUrl = el.dataset.customUrl;
            if (customUrl) {
                return customUrl;
            }
            return window.location.href.split(/[?#]/)[0];
        };
        SocialLinks.prototype.getCurrentTitle = function (el) {
            var customTitle = el.dataset.customTitle;
            if (customTitle) {
                return customTitle;
            }
            return document.querySelector("meta[property='og:title']").getAttribute("content");
        };
        return SocialLinks;
    }());

    exports.SocialLinks = SocialLinks;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
